// Shared category management utilities

export const EXPENSE_CATEGORIES = [
  "Electricity",
  "Water",
  "Gas",
  "Internet",
  "Phone",
  "Rent",
  "Mortgage",
  "Insurance",
  "Groceries",
  "Transportation",
  "Entertainment",
  "Healthcare",
  "Education",
  "Investments",
  "Other",
];

// Storage keys
const CUSTOM_EXPENSE_CATEGORIES_KEY = "customExpenseCategories";
const CUSTOM_TRANSACTION_CATEGORIES_KEY = "customTransactionCategories";

// Expense Categories
export const loadCustomExpenseCategories = (): string[] => {
  const saved = localStorage.getItem(CUSTOM_EXPENSE_CATEGORIES_KEY);
  if (saved) {
    try {
      return JSON.parse(saved);
    } catch (error) {
      console.error("Error loading custom expense categories:", error);
    }
  }
  return [];
};

export const saveCustomExpenseCategories = (categories: string[]): void => {
  localStorage.setItem(
    CUSTOM_EXPENSE_CATEGORIES_KEY,
    JSON.stringify(categories)
  );
};

export const addCustomExpenseCategory = (category: string): string[] => {
  const existing = loadCustomExpenseCategories();
  if (!existing.includes(category)) {
    const updated = [...existing, category];
    saveCustomExpenseCategories(updated);
    return updated;
  }
  return existing;
};

export const deleteCustomExpenseCategory = (category: string): string[] => {
  const existing = loadCustomExpenseCategories();
  const updated = existing.filter((c) => c !== category);
  saveCustomExpenseCategories(updated);
  return updated;
};

export const isCustomExpenseCategory = (category: string): boolean => {
  return !EXPENSE_CATEGORIES.includes(category);
};

export const getAllExpenseCategories = (): string[] => {
  const custom = loadCustomExpenseCategories();
  return [...EXPENSE_CATEGORIES, ...custom].sort();
};

// Transaction Categories (for compatibility with existing system)
export const loadCustomTransactionCategories = (): string[] => {
  const saved = localStorage.getItem(CUSTOM_TRANSACTION_CATEGORIES_KEY);
  if (saved) {
    try {
      return JSON.parse(saved);
    } catch (error) {
      console.error("Error loading custom transaction categories:", error);
    }
  }
  return [];
};

export const saveCustomTransactionCategories = (categories: string[]): void => {
  localStorage.setItem(
    CUSTOM_TRANSACTION_CATEGORIES_KEY,
    JSON.stringify(categories)
  );
};

export const addCustomTransactionCategory = (category: string): string[] => {
  const existing = loadCustomTransactionCategories();
  if (!existing.includes(category)) {
    const updated = [...existing, category];
    saveCustomTransactionCategories(updated);
    return updated;
  }
  return existing;
};
